import React from "react";
import { FieldValues, useForm } from "react-hook-form";
import Button from "../../components/shared/button";
// import { DatePicker } from "../../components/shared/inputs/datePicker";
// import Input, {
//   InputType,
//   Password,
// } from "../../components/shared/inputs/input";
import Select /*TreeSelect*/ from "../../components/shared/inputs/select";
import {
  SvgDelete,
  SvgEdit,
  SvgHelp,
  /*SvgLoaderCircleSmall,*/ SvgType_1,
  SvgType_2,
  SvgType_3,
  SvgType_4,
} from "../../components/svg";

// import sampleImage from "../../styles/images/samples/sample_3.jpg";
// import Checkbox, { CheckboxType } from "components/shared/inputs/checkbox";
import OptionBar from "components/shared/optionBar";
import Radio, { RadioType } from "components/shared/inputs/radio";
import { Tooltip } from "antd";

const Form: React.FC = () => {
  const { control } = useForm<FieldValues>({
    defaultValues: {
      4: true,
      7: true,
      6: true,
      8: "Option3",
      checkox_option_9: true,
      checkox_option_7: true,
      checkox_option_6: true,
      RadioDemo4: "yes",

      RadioDemo2: "table_View",
      RadioDemo6: "leaf",
    },
  });

  return (
    <view data-vertical="" data-adaptive="">
      <view data-space="20" data-container="" data-scroll="">
        <group data-space="20">
          <group
            data-wrap="no"
            data-name="progress_bar"
            data-direction="column"
          >
            <group data-wrap="no" data-gap="20" data-width="auto">
              <group data-direction="column" data-width="auto">
                <group
                  data-background="accent-dark"
                  data-length="30"
                  data-height="30"
                  data-color="white"
                  data-align="center"
                  data-justify="center"
                  data-text-size="13"
                  data-weight="700"
                  data-radius="40"
                  data-shrink="no"
                >
                  1
                </group>
                <group
                  data-direction="column"
                  data-wrap="no"
                  data-length="30"
                  data-gap="1"
                  data-contain=""
                  data-height="autofit"
                >
                  <group
                    data-background="accent-dark"
                    data-length="2"
                    data-height="autofit"
                    data-position="center"
                  ></group>
                </group>
              </group>

              <group data-align="center" data-width="auto">
                <group data-name="progress_bar_title" data-gap="10">
                  <group data-gap="10" data-align="center">
                    <text
                      data-weight="400"
                      data-text-size="22"
                      data-ellipsis=""
                      data-color="grey-color-dark"
                    >
                      Type de projet
                    </text>
                    <Button
                      micro
                      rounded
                      toggleClassName="open"
                      material
                      text=""
                      data-shrink="no"
                      data-help=""
                    //textFirst={true}
                    >
                      <icon data-help="">
                        {" "}
                        <SvgHelp />{" "}
                      </icon>{" "}
                    </Button>
                    <group data-name="help_text">
                      <text
                        data-wrap="wrap"
                        data-weight="400"
                        data-text-size="12"
                        data-ellipsis=""
                        data-color="grey-color-dark"
                      >
                        Sed ut perspiciatis unde omnis iste natus
                      </text>
                    </group>
                  </group>
                </group>
              </group>
            </group>
            <group data-wrap="no" data-gap="20">
              <group
                data-direction="column"
                data-wrap="no"
                data-length="30"
                data-gap="1"
                data-contain=""
              >
                <group
                  data-background="accent-dark"
                  data-length="2"
                  data-height="autofit"
                  data-position="center"
                ></group>
              </group>
              <group
                data-length="autofit"
                data-space-bottom="50"
                data-space-top="20"
              >
                <div className="option_bar custom" data-length="autofit">
                  <label className="" data-length="430">
                    <input
                      type="radio"
                      value="value1"
                      name="radio1"
                    //checked
                    />
                    <wrap
                      data-gap="15"
                      data-min-height="72"
                      data-name="inactive"
                    >
                      <group
                        data-align="center"
                        data-length="80"
                        data-justify="center"
                        data-height="40"
                        data-radius="extra-special"
                        data-background="main"
                        data-color="white"
                      >
                        <icon data-svg-size="24" data-svg-color="white">
                          <SvgType_1 />
                        </icon>
                      </group>
                      <group
                        data-width="auto"
                        data-length="autofit"
                        data-direction="column"
                        data-contain=""
                      >
                        <text
                          data-text-size="large"
                          data-weight="600"
                          data-wrap="wrap"
                          data-ellipsis=""
                        >
                          Rénovation
                        </text>
                      </group>
                    </wrap>
                  </label>
                  <label className="" data-length="430">
                    <input type="radio" value="value2" name="radio1" />
                    <wrap
                      data-gap="15"
                      data-min-height="72"
                      data-name="inactive"
                    >
                      <group
                        data-align="center"
                        data-length="80"
                        data-justify="center"
                        data-height="40"
                        data-radius="extra-special"
                        data-background="main"
                        data-color="white"
                      >
                        <icon data-svg-size="48x" data-svg-color="white">
                          <SvgType_2 />
                        </icon>
                      </group>
                      <group
                        data-width="auto"
                        data-length="autofit"
                        data-direction="column"
                        data-contain=""
                      >
                        <text
                          data-text-size="large"
                          data-weight="600"
                          data-wrap="wrap"
                          data-ellipsis=""
                        >
                          Neuf
                        </text>
                      </group>
                    </wrap>
                  </label>
                </div>
              </group>
            </group>
          </group>

          <group
            data-wrap="no"
            data-name="progress_bar"
            data-direction="column"
          >
            <group data-wrap="no" data-gap="20" data-width="auto">
              <group data-direction="column" data-width="auto">
                <group
                  data-background="accent-dark"
                  data-length="30"
                  data-height="30"
                  data-color="white"
                  data-align="center"
                  data-justify="center"
                  data-text-size="13"
                  data-weight="700"
                  data-radius="40"
                  data-shrink="no"
                >
                  2
                </group>
                <group
                  data-direction="column"
                  data-wrap="no"
                  data-length="30"
                  data-gap="1"
                  data-contain=""
                  data-height="autofit"
                >
                  <group
                    data-background="accent-dark"
                    data-length="2"
                    data-height="autofit"
                    data-position="center"
                  ></group>
                </group>
              </group>
              <group data-align="center" data-width="auto">
                <text
                  data-weight="400"
                  data-text-size="22"
                  data-ellipsis=""
                  data-color="grey-color-dark"
                >
                  Type d’installation
                </text>
              </group>
            </group>
            <group data-wrap="no" data-gap="20">
              <group
                data-direction="column"
                data-wrap="no"
                data-length="30"
                data-gap="1"
                data-contain=""
              >
                <group
                  data-background="accent-dark"
                  data-length="2"
                  data-height="autofit"
                  data-position="center"
                ></group>
              </group>
              <group
                data-length="autofit"
                data-space-bottom="50"
                data-space-top="20"
              >
                <div className="option_bar custom">
                  <label className="" data-length="430">
                    <input type="radio" value="value1" name="radio2" />
                    <wrap
                      data-gap="15"
                      data-min-height="72"
                      data-name="inactive"
                    >
                      <group
                        data-align="center"
                        data-length="80"
                        data-justify="center"
                        data-height="40"
                        data-radius="extra-special"
                        data-background="main"
                        data-color="white"
                      >
                        <icon data-svg-size="24" data-svg-color="white">
                          <SvgType_3 />
                        </icon>
                      </group>
                      <group
                        data-width="auto"
                        data-length="autofit"
                        data-direction="column"
                        data-contain=""
                      >
                        <text
                          data-text-size="large"
                          data-weight="600"
                          data-wrap="wrap"
                          data-ellipsis=""
                        >
                          100 % PAC
                        </text>
                        <text
                          className=""
                          data-wrap="wrap"
                          data-text-size="12"
                          data-contain=""
                          data-ellipsis=""
                        >
                          Ut enim ad minim veniam, quis nostrud exercitation
                          ullamco laboris nisi ut aliquip ex ea commodo con
                        </text>
                      </group>
                    </wrap>
                  </label>
                  <label className="" data-length="430">
                    <input
                      type="radio"
                      value="value2"
                      name="radio2"
                    //checked
                    />
                    <wrap
                      data-gap="15"
                      data-min-height="72"
                      data-name="inactive"
                    >
                      <group
                        data-align="center"
                        data-length="80"
                        data-justify="center"
                        data-height="40"
                        data-radius="extra-special"
                        data-background="main"
                        data-color="white"
                      >
                        <icon data-svg-size="48x" data-svg-color="white">
                          <SvgType_4 />
                        </icon>
                      </group>
                      <group
                        data-width="auto"
                        data-length="autofit"
                        data-direction="column"
                        data-contain=""
                      >
                        <text
                          data-text-size="large"
                          data-weight="600"
                          data-contain=""
                          data-ellipsis=""
                        >
                          Hybride PAC Gaz
                        </text>
                        <text
                          className=""
                          data-wrap="wrap"
                          data-text-size="12"
                          data-contain=""
                          data-ellipsis=""
                        >
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, to
                        </text>
                      </group>
                    </wrap>
                  </label>
                </div>
              </group>
            </group>
          </group>
          <group
            data-wrap="no"
            data-name="progress_bar"
            data-direction="column"
          >
            <group data-wrap="no" data-gap="20" data-width="auto">
              <group data-direction="column" data-width="auto">
                <group
                  data-background="accent-dark"
                  data-length="30"
                  data-height="30"
                  data-color="white"
                  data-align="center"
                  data-justify="center"
                  data-text-size="13"
                  data-weight="700"
                  data-radius="40"
                  data-shrink="no"
                >
                  3
                </group>
                <group
                  data-direction="column"
                  data-wrap="no"
                  data-length="30"
                  data-gap="1"
                  data-contain=""
                  data-height="autofit"
                >
                  <group
                    data-background="accent-dark"
                    data-length="2"
                    data-height="autofit"
                    data-position="center"
                  ></group>
                </group>
              </group>
              <group data-align="center" data-width="auto">
                <text
                  data-weight="400"
                  data-text-size="22"
                  data-ellipsis=""
                  data-color="grey-color-dark"
                >
                  Localisation
                </text>
              </group>
            </group>
            <group data-wrap="no" data-gap="20">
              <group
                data-direction="column"
                data-wrap="no"
                data-length="30"
                data-gap="1"
                data-contain=""
              >
                <group
                  data-background="accent-dark"
                  data-length="2"
                  data-height="autofit"
                  data-position="center"
                ></group>
              </group>
              <group
                data-length="autofit"
                data-space-bottom="50"
                data-space-top="20"
              >
                <group direction="column" data-gap="40">
                  <group data-gap="40">
                    <group
                      data-gap="30"
                      data-direction="column"
                      data-width="auto"
                    >
                      <group data-align="center">
                        {" "}
                        <text
                          data-weight="700"
                          data-text-size="14"
                          data-ellipsis=""
                          data-color="grey-color-dark"
                        >
                          Small
                        </text>{" "}
                      </group>
                      <group>
                        <material className="empty" data-length="450">
                          <div className="field">
                            <label className="form_fields">
                              <div className="data_label">
                                <text data-ellipsis="">Input component</text>
                                <Tooltip
                                  arrow={false}
                                  color="var(--accent-dark)"
                                  space={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="5"
                                    >
                                      <text data-weight="700">
                                        This's a tooltip
                                      </text>
                                    </group>
                                  }
                                >
                                  <icon data-help="">
                                    <SvgHelp />
                                  </icon>
                                </Tooltip>
                              </div>
                              <div className="field_cont">
                                <input
                                  type="text"
                                  placeholder=" "
                                  name="asd"
                                  value=""
                                />
                                <div
                                  className="marker"
                                  data-radius="less-special"
                                >
                                  <text>mm</text>
                                </div>
                                <i></i>
                              </div>
                            </label>
                          </div>
                        </material>
                      </group>
                      <group>
                        <material className="" data-length="450">
                          <div className="field">
                            <label className="form_fields">
                              <div className="data_label">
                                <text data-ellipsis="">Input component</text>
                                <Tooltip
                                  arrow={false}
                                  color="var(--accent-dark)"
                                  space={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="5"
                                    >
                                      <text data-weight="700">
                                        This's a tooltip
                                      </text>
                                    </group>
                                  }
                                >
                                  <icon data-help="">
                                    <SvgHelp />
                                  </icon>
                                </Tooltip>
                              </div>
                              <div className="field_cont">
                                <input
                                  type="text"
                                  placeholder=" "
                                  name="asd"
                                  value="Input value"
                                />
                                <div
                                  className="marker"
                                  data-radius="less-special"
                                >
                                  <text>mm</text>
                                </div>
                                <i></i>
                              </div>
                            </label>
                          </div>
                        </material>
                      </group>
                      <group>
                        <material className="" data-length="450">
                          <div className="field">
                            <label className="form_fields">
                              <div className="data_label">
                                <text data-ellipsis="">
                                  Entrez votre mot de passe
                                </text>
                              </div>
                              <div className="field_cont">
                                <input
                                  type="text"
                                  placeholder=" "
                                  name="asd"
                                  value=""
                                />
                                <div
                                  className="button marker"
                                  data-radius="less-special"
                                >
                                  <text>mm</text>
                                </div>
                                <i></i>
                              </div>
                            </label>
                          </div>
                        </material>
                      </group>
                      <group>
                        <material className="" data-length="450">
                          <div className="field">
                            <label className="form_fields">
                              <div className="data_label">
                                <text data-wrap="wrap">Input component</text>
                                <Tooltip
                                  arrow={false}
                                  color="var(--accent-dark)"
                                  space={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="5"
                                    >
                                      <text data-weight="700">
                                        This's a tooltip
                                      </text>
                                    </group>
                                  }
                                >
                                  <icon data-help="">
                                    <SvgHelp />
                                  </icon>
                                </Tooltip>
                              </div>
                              <div className="field_cont">
                                <input
                                  type="text"
                                  placeholder=" "
                                  name="asd"
                                  value="Input value"
                                />
                                <div
                                  className="button marker"
                                  data-radius="less-special"
                                >
                                  <text>mm</text>
                                </div>
                                <i></i>
                              </div>
                            </label>
                          </div>
                        </material>
                      </group>
                      <group>
                        <material className="" data-length="450">
                          <div className="field">
                            <label className="form_fields">
                              <div className="data_label">
                                <text data-wrap="wrap">
                                  Entrez votre mot de passe
                                </text>
                              </div>
                              <div className="field_cont">
                                <input
                                  type="password"
                                  placeholder=""
                                  name="password"
                                  value="Entrez votre mot de passe"
                                ></input>
                                <div className="button">
                                  <icon>visibility</icon>
                                </div>
                                <i></i>
                              </div>
                            </label>
                          </div>
                        </material>
                      </group>
                      <group>
                        <material className="" data-length="450">
                          <div className="field">
                            <label className="form_fields">
                              <div className="data_label">
                                <text data-ellipsis="">Input component</text>
                                <Tooltip
                                  arrow={false}
                                  color="var(--accent-dark)"
                                  space={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="5"
                                    >
                                      <text data-weight="700">
                                        This's a tooltip
                                      </text>
                                    </group>
                                  }
                                >
                                  <icon data-help="">
                                    <SvgHelp />
                                  </icon>
                                </Tooltip>
                              </div>
                              <div className="field_cont">
                                <input
                                  type="text"
                                  placeholder=" "
                                  name="asd"
                                  value="Input value"
                                />
                                <div
                                  className="marker"
                                  data-radius="less-special"
                                >
                                  <text>mm</text>
                                </div>
                                <i></i>
                              </div>
                            </label>
                          </div>
                        </material>
                      </group>
                      <group>
                        <material className=" info_message" data-length="450">
                          <div className="field">
                            <label className="form_fields">
                              <div className="data_label">
                                <text data-ellipsis="">Input component</text>
                                <Tooltip
                                  arrow={false}
                                  color="var(--accent-dark)"
                                  space={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="5"
                                    >
                                      <text data-weight="700">
                                        This's a tooltip
                                      </text>
                                    </group>
                                  }
                                >
                                  <icon data-help="">
                                    <SvgHelp />
                                  </icon>
                                </Tooltip>
                              </div>
                              <div className="field_cont">
                                <input
                                  type="text"
                                  placeholder=" "
                                  name="asd"
                                  value="Input value"
                                />
                                <div
                                  className="marker"
                                  data-radius="less-special"
                                >
                                  <text>mm</text>
                                </div>
                                <i></i>
                              </div>
                            </label>
                          </div>
                          <infomessage>
                            <text data-wrap="wrap" className="errorMessage">
                              Voici un exemple de petit tooltip d’informations
                            </text>
                          </infomessage>
                        </material>
                      </group>
                      <group>
                        <material className="validationError" data-length="450">
                          <div className="field">
                            <label className="form_fields">
                              <div className="data_label">
                                <text data-ellipsis="">Input component</text>
                                <Tooltip
                                  arrow={false}
                                  color="var(--accent-dark)"
                                  space={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="5"
                                    >
                                      <text data-weight="700">
                                        This's a tooltip
                                      </text>
                                    </group>
                                  }
                                >
                                  <icon data-help="">
                                    <SvgHelp />
                                  </icon>
                                </Tooltip>
                              </div>
                              <div className="field_cont">
                                <input
                                  type="text"
                                  placeholder=" "
                                  name="asd"
                                  value="Input value"
                                />
                                <div
                                  className="marker"
                                  data-radius="less-special"
                                >
                                  <text>mm</text>
                                </div>
                                <i></i>
                              </div>
                            </label>
                          </div>
                          <errormessage>
                            <text data-wrap="wrap" className="errorMessage">
                              Veuillez vérifier les informations
                            </text>
                          </errormessage>
                        </material>
                      </group>
                      <separator data-horizontal=""></separator>

                      <group
                        data-name="toggle"
                        data-length="450"
                        data-direction="column"
                      >
                        <group
                          data-name="toggle_cont"
                          data-space="10"
                          data-space-left="15"
                          data-height="48"
                          data-border=""
                          data-align="center"
                          data-gap="10"
                          data-radius="special"
                          data-color="grey-color-dark"
                          data-wrap="no"
                        >
                          <group data-width="auto" data-fit="1">
                            <text
                              //data-space="5"
                              data-color="grey-color-mid"
                              data-text-size="15"
                            >
                              Réseau ECS géré par la chaudière seule
                            </text>
                          </group>
                          <OptionBar fixed animate>
                            <Radio
                              control={control}
                              radioType={RadioType.Button}
                              name="RadioDemo4"
                              radioValue="yes"
                              label="Oui"
                            />
                            <Radio
                              control={control}
                              radioType={RadioType.Button}
                              name="RadioDemo4"
                              radioValue="no"
                              label="Non"
                            />
                          </OptionBar>
                        </group>
                      </group>

                      <group
                        data-name="toggle"
                        data-length="450"
                        className="validationError"
                      >
                        <group
                          data-name="toggle_cont"
                          data-space="10"
                          data-space-left="15"
                          data-height="48"
                          data-border=""
                          data-align="center"
                          data-gap="10"
                          data-radius="special"
                          data-color="grey-color-dark"
                          data-wrap="no"
                        >
                          <group data-width="auto" data-fit="1">
                            <text
                              //data-space="5"
                              data-color="grey-color-mid"
                              data-text-size="15"
                            >
                              Réseau ECS géré par la chaudière seule
                            </text>
                          </group>
                          <OptionBar fixed animate>
                            <Radio
                              control={control}
                              radioType={RadioType.Button}
                              name="RadioDemo4"
                              radioValue="yes"
                              label="Oui"
                            />
                            <Radio
                              control={control}
                              radioType={RadioType.Button}
                              name="RadioDemo4"
                              radioValue="no"
                              label="Non"
                            />
                          </OptionBar>
                        </group>
                        <errormessage>
                          <text data-wrap="wrap" className="errorMessage">
                            Veuillez vérifier les informations
                          </text>
                        </errormessage>
                      </group>

                      <group
                        data-name="toggle"
                        data-length="450"
                        className="info_message"
                      >
                        <group
                          data-name="toggle_cont"
                          data-space="10"
                          data-space-left="15"
                          data-height="48"
                          data-border=""
                          data-align="center"
                          data-gap="10"
                          data-radius="special"
                          data-color="grey-color-dark"
                          data-wrap="no"
                        >
                          <group data-width="auto" data-fit="1">
                            <text
                              data-color="grey-color-mid"
                              data-text-size="15"
                            >
                              Réseau ECS géré par la chaudière seule
                            </text>
                          </group>
                          <OptionBar fixed animate>
                            <Radio
                              control={control}
                              radioType={RadioType.Button}
                              name="RadioDemo4"
                              radioValue="yes"
                              label="Oui"
                            />
                            <Radio
                              control={control}
                              radioType={RadioType.Button}
                              name="RadioDemo4"
                              radioValue="no"
                              label="Non"
                            />
                          </OptionBar>
                        </group>
                        <infomessage>
                          <text data-wrap="wrap" className="errorMessage">
                            Voici un exemple de petit tooltip d’informations
                          </text>
                        </infomessage>
                      </group>

                      <separator data-horizontal=""></separator>

                      <group>
                        <material className="empty" data-length="450">
                          <Select
                            //size="large"
                            //icon="person"
                            label="Select component"
                            //placeholder="Select a person"
                            name="dropdown"
                            //dataLength="400"
                            allowClear
                            options={[
                              "Wolverine",
                              "Spider-Man",
                              "Thor",
                              "Iron Man",
                              "Hulk",
                              "Captain America",
                              "Daredevil",
                              "Punisher",
                              { value: 1, text: "Yondu Udonta" },
                              { value: "Star Lord" },
                            ]}
                          />
                        </material>
                      </group>

                      <group>
                        <material
                          className="empty validationError"
                          data-length="450"
                        >
                          <Select
                            //size="large"
                            //icon="person"
                            label="Select component"
                            //placeholder="Select a person"
                            name="dropdown"
                            //dataLength="400"
                            allowClear
                            options={[
                              "Wolverine",
                              "Spider-Man",
                              "Thor",
                              "Iron Man",
                              "Hulk",
                              "Captain America",
                              "Daredevil",
                              "Punisher",
                              { value: 1, text: "Yondu Udonta" },
                              { value: "Star Lord" },
                            ]}
                          />
                          <errormessage>
                            <text data-wrap="wrap" className="errorMessage">
                              Veuillez vérifier les informations
                            </text>
                          </errormessage>
                        </material>
                      </group>

                      <group>
                        <material
                          className="empty info_message"
                          data-length="450"
                        >
                          <Select
                            //size="large"
                            //icon="person"
                            label="Select component"
                            //placeholder="Select a person"
                            name="dropdown"
                            //dataLength="400"
                            allowClear
                            options={[
                              "Wolverine",
                              "Spider-Man",
                              "Thor",
                              "Iron Man",
                              "Hulk",
                              "Captain America",
                              "Daredevil",
                              "Punisher",
                              { value: 1, text: "Yondu Udonta" },
                              { value: "Star Lord" },
                            ]}
                          />
                          <infomessage>
                            <text data-wrap="wrap" className="errorMessage">
                              Voici un exemple de petit tooltip d’informations
                            </text>
                          </infomessage>
                        </material>
                      </group>
                    </group>

                    <group
                      data-gap="30"
                      data-direction="column"
                      data-width="auto"
                    >
                      <group data-align="center">
                        {" "}
                        <text
                          data-weight="700"
                          data-text-size="14"
                          data-ellipsis=""
                          data-color="grey-color-dark"
                        >
                          Large
                        </text>{" "}
                      </group>

                      <group
                        data-gap="10"
                        data-space="10"
                        data-background="accent-xtralight"
                        data-radius="10"
                        data-direction="column"
                      >
                        <group data-align="center" data-width="auto">
                          {" "}
                          <text
                            data-weight="600"
                            data-text-size="17"
                            data-ellipsis=""
                            data-color="grey-color-dark"
                            data-space-horizontal="10"
                          >
                            Contraintes de local technique (facultatif)
                          </text>{" "}
                        </group>
                        <group data-gap="10">
                          <group data-length="autofit">
                            <material
                              className="empty"
                              data-size="large"
                              data-length="autofit"
                            >
                              <div className="field">
                                <label className="form_fields">
                                  <div className="data_label">
                                    <text data-ellipsis="">
                                      Input component
                                    </text>
                                    <Tooltip
                                      arrow={false}
                                      color="var(--accent-dark)"
                                      space={false}
                                      title={
                                        <group
                                          data-direction="column"
                                          data-gap="10"
                                          data-space="5"
                                        >
                                          <text data-weight="700">
                                            This's a tooltip
                                          </text>
                                        </group>
                                      }
                                    >
                                      <icon data-help="">
                                        <SvgHelp />
                                      </icon>
                                    </Tooltip>
                                  </div>
                                  <div className="field_cont">
                                    <input
                                      type="text"
                                      placeholder=" "
                                      name="asd"
                                      value=""
                                    />
                                    <div
                                      className="marker"
                                      data-radius="less-special"
                                    >
                                      <text>mm</text>
                                    </div>
                                    <i></i>
                                  </div>
                                </label>
                              </div>
                            </material>
                          </group>
                          <group data-length="autofit">
                            <material
                              className=""
                              data-size="large"
                              data-length="autofit"
                            >
                              <div className="field">
                                <label className="form_fields">
                                  <div className="data_label">
                                    <text data-ellipsis="">
                                      Input component
                                    </text>
                                    <Tooltip
                                      arrow={false}
                                      color="var(--accent-dark)"
                                      space={false}
                                      title={
                                        <group
                                          data-direction="column"
                                          data-gap="10"
                                          data-space="5"
                                        >
                                          <text data-weight="700">
                                            This's a tooltip
                                          </text>
                                        </group>
                                      }
                                    >
                                      <icon data-help="">
                                        <SvgHelp />
                                      </icon>
                                    </Tooltip>
                                  </div>
                                  <div className="field_cont">
                                    <input
                                      type="text"
                                      placeholder=" "
                                      name="asd"
                                      value="Input value"
                                    />
                                    <div
                                      className="marker"
                                      data-radius="less-special"
                                    >
                                      <text>mm</text>
                                    </div>
                                    <i></i>
                                  </div>
                                </label>
                              </div>
                            </material>
                          </group>
                        </group>
                      </group>

                      <group>
                        <material
                          className=""
                          data-size="large"
                          data-length="450"
                        >
                          <div className="field">
                            <label className="form_fields">
                              <div className="data_label">
                                <text data-ellipsis="">Input component</text>
                                <Tooltip
                                  arrow={false}
                                  color="var(--accent-dark)"
                                  space={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="5"
                                    >
                                      <text data-weight="700">
                                        This's a tooltip
                                      </text>
                                    </group>
                                  }
                                >
                                  <icon data-help="">
                                    <SvgHelp />
                                  </icon>
                                </Tooltip>
                              </div>
                              <div className="field_cont">
                                <input
                                  type="text"
                                  placeholder=" "
                                  name="asd"
                                  value="Input value"
                                />
                                <div
                                  className="marker"
                                  data-radius="less-special"
                                >
                                  <text>mm</text>
                                </div>
                                <i></i>
                              </div>
                            </label>
                          </div>
                        </material>
                      </group>
                      <group>
                        <material
                          className=" info_message"
                          data-size="large"
                          data-length="450"
                        >
                          <div className="field">
                            <label className="form_fields">
                              <div className="data_label">
                                <text data-ellipsis="">Input component</text>
                                <Tooltip
                                  arrow={false}
                                  color="var(--accent-dark)"
                                  space={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="5"
                                    >
                                      <text data-weight="700">
                                        This's a tooltip
                                      </text>
                                    </group>
                                  }
                                >
                                  <icon data-help="">
                                    <SvgHelp />
                                  </icon>
                                </Tooltip>
                              </div>
                              <div className="field_cont">
                                <input
                                  type="text"
                                  placeholder=" "
                                  name="asd"
                                  value="Input value"
                                />
                                <div
                                  className="marker"
                                  data-radius="less-special"
                                >
                                  <text>mm</text>
                                </div>
                                <i></i>
                              </div>
                            </label>
                          </div>
                          <infomessage>
                            <text data-wrap="wrap" className="errorMessage">
                              Voici un exemple de petit tooltip d’informations
                            </text>
                          </infomessage>
                        </material>
                      </group>
                      <group>
                        <material
                          className="validationError"
                          data-size="large"
                          data-length="450"
                        >
                          <div className="field">
                            <label className="form_fields">
                              <div className="data_label">
                                <text data-ellipsis="">Input component</text>
                                <Tooltip
                                  arrow={false}
                                  color="var(--accent-dark)"
                                  space={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="5"
                                    >
                                      <text data-weight="700">
                                        This's a tooltip
                                      </text>
                                    </group>
                                  }
                                >
                                  <icon data-help="">
                                    <SvgHelp />
                                  </icon>
                                </Tooltip>
                              </div>
                              <div className="field_cont">
                                <input
                                  type="text"
                                  placeholder=" "
                                  name="asd"
                                  value="Input value"
                                />
                                <div
                                  className="marker"
                                  data-radius="less-special"
                                >
                                  <text>mm</text>
                                </div>
                                <i></i>
                              </div>
                            </label>
                          </div>
                          <errormessage>
                            <text data-wrap="wrap" className="errorMessage">
                              Veuillez vérifier les informations
                            </text>
                          </errormessage>
                        </material>
                      </group>
                      <separator data-horizontal=""></separator>

                      <group
                        data-name="toggle"
                        data-size="large"
                        data-length="450"
                        data-direction="column"
                      >
                        <group
                          data-name="toggle_cont"
                          data-space="10"
                          data-space-left="15"
                          data-height="60"
                          data-border=""
                          data-align="center"
                          data-gap="10"
                          data-radius="special"
                          data-color="grey-color-dark"
                          data-wrap="no"
                        >
                          <group data-width="auto" data-fit="1">
                            <text
                              data-color="grey-color-mid"
                              data-text-size="15"
                            >
                              Réseau ECS géré par la chaudière seule
                            </text>
                          </group>
                          <OptionBar fixed animate>
                            <Radio
                              control={control}
                              radioType={RadioType.Button}
                              name="RadioDemo4"
                              radioValue="yes"
                              label="Oui"
                            />
                            <Radio
                              control={control}
                              radioType={RadioType.Button}
                              name="RadioDemo4"
                              radioValue="no"
                              label="Non"
                            />
                          </OptionBar>
                        </group>
                      </group>

                      <group
                        data-name="toggle"
                        data-size="large"
                        data-length="450"
                        className="validationError"
                      >
                        <group
                          data-name="toggle_cont"
                          data-space="10"
                          data-space-left="15"
                          data-height="60"
                          data-border=""
                          data-align="center"
                          data-gap="10"
                          data-radius="special"
                          data-color="grey-color-dark"
                          data-wrap="no"
                        >
                          <group data-width="auto" data-fit="1">
                            <text
                              data-color="grey-color-mid"
                              data-text-size="15"
                            >
                              Réseau ECS géré par la chaudière seule
                            </text>
                          </group>
                          <OptionBar fixed animate>
                            <Radio
                              control={control}
                              radioType={RadioType.Button}
                              name="RadioDemo4"
                              radioValue="yes"
                              label="Oui"
                            />
                            <Radio
                              control={control}
                              radioType={RadioType.Button}
                              name="RadioDemo4"
                              radioValue="no"
                              label="Non"
                            />
                          </OptionBar>
                        </group>
                        <errormessage>
                          <text data-wrap="wrap" className="errorMessage">
                            Veuillez vérifier les informations
                          </text>
                        </errormessage>
                      </group>

                      <group
                        data-name="toggle"
                        data-size="large"
                        data-length="450"
                        className="info_message"
                      >
                        <group
                          data-name="toggle_cont"
                          data-space="10"
                          data-space-left="15"
                          data-height="60"
                          data-border=""
                          data-align="center"
                          data-gap="10"
                          data-radius="special"
                          data-color="grey-color-dark"
                          data-wrap="no"
                        >
                          <group data-width="auto" data-fit="1">
                            <text
                              data-color="grey-color-mid"
                              data-text-size="15"
                            >
                              Réseau ECS géré par la chaudière seule
                            </text>
                          </group>
                          <OptionBar fixed animate>
                            <Radio
                              control={control}
                              radioType={RadioType.Button}
                              name="RadioDemo4"
                              radioValue="yes"
                              label="Oui"
                            />
                            <Radio
                              control={control}
                              radioType={RadioType.Button}
                              name="RadioDemo4"
                              radioValue="no"
                              label="Non"
                            />
                          </OptionBar>
                        </group>
                        <infomessage>
                          <text data-wrap="wrap" className="errorMessage">
                            Voici un exemple de petit tooltip d’informations
                          </text>
                        </infomessage>
                      </group>

                      <separator data-horizontal=""></separator>

                      <group>
                        <material
                          className="empty"
                          data-size="large"
                          data-length="450"
                        >
                          <Select
                            //size="large"
                            //icon="person"
                            label="Select component"
                            //placeholder="Select a person"
                            name="dropdown"
                            //dataLength="400"
                            allowClear
                            options={[
                              "Wolverine",
                              "Spider-Man",
                              "Thor",
                              "Iron Man",
                              "Hulk",
                              "Captain America",
                              "Daredevil",
                              "Punisher",
                              { value: 1, text: "Yondu Udonta" },
                              { value: "Star Lord" },
                            ]}
                          />
                        </material>
                      </group>

                      <group>
                        <material
                          className="empty validationError"
                          data-size="large"
                          data-length="450"
                        >
                          <Select
                            //size="large"
                            //icon="person"
                            label="Select component"
                            //placeholder="Select a person"
                            name="dropdown"
                            //dataLength="400"
                            allowClear
                            options={[
                              "Wolverine",
                              "Spider-Man",
                              "Thor",
                              "Iron Man",
                              "Hulk",
                              "Captain America",
                              "Daredevil",
                              "Punisher",
                              { value: 1, text: "Yondu Udonta" },
                              { value: "Star Lord" },
                            ]}
                          />
                          <errormessage>
                            <text data-wrap="wrap" className="errorMessage">
                              Veuillez vérifier les informations
                            </text>
                          </errormessage>
                        </material>
                      </group>

                      <group>
                        <material
                          className="empty info_message"
                          data-size="large"
                          data-length="450"
                        >
                          <Select
                            //size="large"
                            //icon="person"
                            label="Select component"
                            //placeholder="Select a person"
                            name="dropdown"
                            //dataLength="400"
                            allowClear
                            options={[
                              "Wolverine",
                              "Spider-Man",
                              "Thor",
                              "Iron Man",
                              "Hulk",
                              "Captain America",
                              "Daredevil",
                              "Punisher",
                              { value: 1, text: "Yondu Udonta" },
                              { value: "Star Lord" },
                            ]}
                          />
                          <infomessage>
                            <text data-wrap="wrap" className="errorMessage">
                              Voici un exemple de petit tooltip d’informations
                            </text>
                          </infomessage>
                        </material>
                      </group>
                    </group>
                  </group>
                </group>
              </group>
            </group>
          </group>

          <group
            data-wrap="no"
            data-name="progress_bar"
            data-direction="column"
          >
            <group data-wrap="no" data-gap="20" data-width="auto">
              <group data-direction="column" data-width="auto">
                <group
                  data-background="accent-dark"
                  data-length="30"
                  data-height="30"
                  data-color="white"
                  data-align="center"
                  data-justify="center"
                  data-text-size="13"
                  data-weight="700"
                  data-radius="40"
                  data-shrink="no"
                >
                  4
                </group>
                <group
                  data-direction="column"
                  data-wrap="no"
                  data-length="30"
                  data-gap="1"
                  data-contain=""
                  data-height="autofit"
                >
                  <group
                    data-background="accent-dark"
                    data-length="2"
                    data-height="autofit"
                    data-position="center"
                  ></group>
                </group>
              </group>
              <group data-align="center" data-width="auto">
                <text
                  data-weight="400"
                  data-text-size="22"
                  data-ellipsis=""
                  data-color="grey-color-dark"
                >
                  Circuits chauffage
                </text>
              </group>
            </group>
            <group data-wrap="no" data-gap="20">
              <group
                data-direction="column"
                data-wrap="no"
                data-length="30"
                data-gap="1"
                data-contain=""
              >
                <group
                  data-background="accent-dark"
                  data-length="2"
                  data-height="autofit"
                  data-position="center"
                ></group>
              </group>
              <group
                data-length="autofit"
                data-space-bottom="50"
                data-space-top="20"
              >
                <group data-gap="30">
                  <group
                    data-gap="10"
                    data-space="20"
                    data-border=""
                    data-radius="special"
                    data-length="480"
                  >
                    <group>
                      <group data-gap="10" data-width="auto">
                        <text
                          data-text-size="large"
                          data-color="grey-color-dark"
                        >
                          Circuit 1
                        </text>
                        <Button
                          micro
                          rounded
                          outline
                          data-color="grey-color-dark"
                        >
                          <icon
                            data-svg-color="grey-color-dark"
                            data-svg-size="16"
                          >
                            <SvgEdit />
                          </icon>
                        </Button>
                      </group>
                      <group
                        data-gap="10"
                        data-width="auto"
                        data-position="right"
                      >
                        <Button micro rounded outline data-color="error-color">
                          <icon data-svg-color="error-color" data-svg-size="16">
                            <SvgDelete />
                          </icon>
                        </Button>
                      </group>
                    </group>
                    <group data-gap="20">
                      <group>
                        <material className="empty" data-length="autofit">
                          <Select
                            //size="large"
                            //icon="person"
                            label="Select component"
                            //placeholder="Select a person"
                            name="dropdown"
                            //dataLength="400"
                            allowClear
                            options={[
                              "Wolverine",
                              "Spider-Man",
                              "Thor",
                              "Iron Man",
                              "Hulk",
                              "Captain America",
                              "Daredevil",
                              "Punisher",
                              { value: 1, text: "Yondu Udonta" },
                              { value: "Star Lord" },
                            ]}
                          />
                        </material>
                      </group>
                      <group>
                        <material className="empty" data-length="autofit">
                          <div className="field">
                            <label className="form_fields">
                              <div className="data_label">
                                <text data-wrap="wrap">Input component</text>
                                <Tooltip
                                  arrow={false}
                                  color="var(--accent-dark)"
                                  space={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="5"
                                    >
                                      <text data-weight="700">
                                        This is a tooltip
                                      </text>
                                      <text data-wrap="wrap" data-weight="400">
                                        Lorem Ipsum is simply dummy text of the
                                        printing and typesetting industry.
                                      </text>
                                    </group>
                                  }
                                >
                                  <icon data-help="">
                                    <SvgHelp />
                                  </icon>
                                </Tooltip>
                              </div>
                              <div className="field_cont">
                                <input
                                  type="text"
                                  placeholder=" "
                                  name="asd"
                                  value=""
                                />
                                <div
                                  className="marker"
                                  data-radius="less-special"
                                >
                                  <text>mm</text>
                                </div>
                                <i></i>
                              </div>
                            </label>
                          </div>
                        </material>
                      </group>
                    </group>
                  </group>
                  <group
                    data-gap="10"
                    data-space="20"
                    data-radius="special"
                    data-length="480"
                    data-border-color="border-color"
                    data-border="dashed"
                    data-interactive=""
                    data-cursor="pointer"
                  >
                    <group
                      data-gap="20"
                      data-justify="center"
                      data-align="center"
                    >
                      <group data-width="auto" data-gap="10">
                        <icon>add</icon>
                        <text
                          data-text-size="large"
                          data-color="grey-color-dark"
                        >
                          Ajouter un circuit
                        </text>
                      </group>
                    </group>
                  </group>
                </group>
              </group>
            </group>
          </group>

          <group
            data-wrap="no"
            data-name="progress_bar"
            data-direction="column"
          >
            <group data-wrap="no" data-gap="20" data-width="auto">
              <group data-direction="column" data-width="auto">
                <group
                  data-background="accent-dark"
                  data-length="30"
                  data-height="30"
                  data-color="white"
                  data-align="center"
                  data-justify="center"
                  data-text-size="13"
                  data-weight="700"
                  data-radius="40"
                  data-shrink="no"
                >
                  5
                </group>
                <group
                  data-direction="column"
                  data-wrap="no"
                  data-length="30"
                  data-gap="1"
                  data-contain=""
                  data-height="autofit"
                >
                  {/*<group data-background="accent-dark" data-length="2" data-height="autofit" data-position="center"></group>*/}
                </group>
              </group>
              <group data-align="center" data-width="auto">
                <text
                  data-weight="400"
                  data-text-size="22"
                  data-ellipsis=""
                  data-color="grey-color-dark"
                >
                  Notes supplémentaires
                </text>
              </group>
            </group>
            <group data-wrap="no" data-gap="20">
              <group
                data-direction="column"
                data-wrap="no"
                data-length="30"
                data-gap="1"
                data-contain=""
              >
                {/*<group data-background="accent-dark" data-length="2" data-height="autofit" data-position="center"></group>*/}
              </group>
              <group
                data-length="autofit"
                data-space-bottom="50"
                data-space-top="20"
              >
                <group data-gap="30">
                  <div
                    className="option_bar custom image"
                    data-length="autofit"
                  >
                    <label className="" data-length="260">
                      <input type="radio" value="value" name="radio" />
                      <wrap
                        data-gap="15"
                        data-min-height="72"
                        data-name="inactive"
                      >
                        <group
                          data-gap="10"
                          data-radius="extra-special"
                          data-contain=""
                        >
                          <group
                            data-gap="20"
                            data-height="100"
                            data-interactive=""
                            data-cursor="pointer"
                          >
                            <picture data-position="absolute">
                              <img
                                src="/src/styles/images/cards/Card-Batiment.png"
                                alt=""
                              />
                            </picture>
                            <group
                              data-width="auto"
                              data-height="autofit"
                              data-space="20"
                              data-gap="10"
                              data-direction="column"
                            >
                              <text
                                data-position="bottom"
                                data-text-size="large"
                                data-color="white"
                              >
                                Logements
                              </text>
                            </group>
                          </group>
                        </group>
                      </wrap>
                    </label>
                    <label className="" data-length="260">
                      <input type="radio" value="value" name="radio" />
                      <wrap
                        data-gap="15"
                        data-min-height="72"
                        data-name="inactive"
                      >
                        <group
                          data-gap="10"
                          data-radius="extra-special"
                          data-contain=""
                        >
                          <group
                            data-gap="20"
                            data-height="100"
                            data-interactive=""
                            data-cursor="pointer"
                          >
                            <picture data-position="absolute">
                              <img
                                src="/src/styles/images/cards/Card-Batiment-1.png"
                                alt=""
                              />
                            </picture>
                            <group
                              data-width="auto"
                              data-height="autofit"
                              data-space="20"
                              data-gap="10"
                              data-direction="column"
                            >
                              <text
                                data-position="bottom"
                                data-text-size="large"
                                data-color="white"
                              >
                                Logements
                              </text>
                            </group>
                          </group>
                        </group>
                      </wrap>
                    </label>
                    <label className="" data-length="260">
                      <input type="radio" value="value" name="radio" />
                      <wrap
                        data-gap="15"
                        data-min-height="72"
                        data-name="inactive"
                      >
                        <group
                          data-gap="10"
                          data-radius="extra-special"
                          data-contain=""
                        >
                          <group
                            data-gap="20"
                            data-height="100"
                            data-interactive=""
                            data-cursor="pointer"
                          >
                            <picture data-position="absolute">
                              <img
                                src="/src/styles/images/cards/Card-Batiment-2.png"
                                alt=""
                              />
                            </picture>
                            <group
                              data-width="auto"
                              data-height="autofit"
                              data-space="20"
                              data-gap="10"
                              data-direction="column"
                            >
                              <text
                                data-position="bottom"
                                data-text-size="large"
                                data-color="white"
                              >
                                Logements
                              </text>
                            </group>
                          </group>
                        </group>
                      </wrap>
                    </label>
                    <label className="" data-length="260">
                      <input type="radio" value="value" name="radio" />
                      <wrap
                        data-gap="15"
                        data-min-height="72"
                        data-name="inactive"
                      >
                        <group
                          data-gap="10"
                          data-radius="extra-special"
                          data-contain=""
                        >
                          <group
                            data-gap="20"
                            data-height="100"
                            data-interactive=""
                            data-cursor="pointer"
                          >
                            <picture data-position="absolute">
                              <img
                                src="/src/styles/images/cards/Card-Batiment-3.png"
                                alt=""
                              />
                            </picture>
                            <group
                              data-width="auto"
                              data-height="autofit"
                              data-space="20"
                              data-gap="10"
                              data-direction="column"
                            >
                              <text
                                data-position="bottom"
                                data-text-size="large"
                                data-color="white"
                              >
                                Logements
                              </text>
                            </group>
                          </group>
                        </group>
                      </wrap>
                    </label>
                    <label className="" data-length="260">
                      <input type="radio" value="value" name="radio" />
                      <wrap
                        data-gap="15"
                        data-min-height="72"
                        data-name="inactive"
                      >
                        <group
                          data-gap="10"
                          data-radius="extra-special"
                          data-contain=""
                        >
                          <group
                            data-gap="20"
                            data-height="100"
                            data-interactive=""
                            data-cursor="pointer"
                          >
                            <picture data-position="absolute">
                              <img
                                src="/src/styles/images/cards/Card-Batiment-4.png"
                                alt=""
                              />
                            </picture>
                            <group
                              data-width="auto"
                              data-height="autofit"
                              data-space="20"
                              data-gap="10"
                              data-direction="column"
                            >
                              <text
                                data-position="bottom"
                                data-text-size="large"
                                data-color="white"
                              >
                                Logements
                              </text>
                            </group>
                          </group>
                        </group>
                      </wrap>
                    </label>
                    <label className="" data-length="260">
                      <input type="radio" value="value" name="radio" />
                      <wrap
                        data-gap="15"
                        data-min-height="72"
                        data-name="inactive"
                      >
                        <group
                          data-gap="10"
                          data-radius="extra-special"
                          data-contain=""
                        >
                          <group
                            data-gap="20"
                            data-height="100"
                            data-interactive=""
                            data-cursor="pointer"
                          >
                            <picture data-position="absolute">
                              <img
                                src="/src/styles/images/cards/Card-Batiment-5.png"
                                alt=""
                              />
                            </picture>
                            <group
                              data-width="auto"
                              data-height="autofit"
                              data-space="20"
                              data-gap="10"
                              data-direction="column"
                            >
                              <text
                                data-position="bottom"
                                data-text-size="large"
                                data-color="white"
                              >
                                Logements
                              </text>
                            </group>
                          </group>
                        </group>
                      </wrap>
                    </label>
                    <label className="" data-length="260">
                      <input type="radio" value="value" name="radio" />
                      <wrap
                        data-gap="15"
                        data-min-height="72"
                        data-name="inactive"
                      >
                        <group
                          data-gap="10"
                          data-radius="extra-special"
                          data-contain=""
                        >
                          <group
                            data-gap="20"
                            data-height="100"
                            data-interactive=""
                            data-cursor="pointer"
                          >
                            <picture data-position="absolute">
                              <img
                                src="/src/styles/images/cards/Card-Batiment-6.png"
                                alt=""
                              />
                            </picture>
                            <group
                              data-width="auto"
                              data-height="autofit"
                              data-space="20"
                              data-gap="10"
                              data-direction="column"
                            >
                              <text
                                data-position="bottom"
                                data-text-size="large"
                                data-color="white"
                              >
                                Logements
                              </text>
                            </group>
                          </group>
                        </group>
                      </wrap>
                    </label>
                    <label className="" data-length="260">
                      <input type="radio" value="value" name="radio" />
                      <wrap
                        data-gap="15"
                        data-min-height="72"
                        data-name="inactive"
                      >
                        <group
                          data-gap="10"
                          data-radius="extra-special"
                          data-contain=""
                        >
                          <group
                            data-gap="20"
                            data-height="100"
                            data-interactive=""
                            data-cursor="pointer"
                          >
                            <picture data-position="absolute">
                              <img
                                src="/src/styles/images/cards/Card-Batiment-7.png"
                                alt=""
                              />
                            </picture>
                            <group
                              data-width="auto"
                              data-height="autofit"
                              data-space="20"
                              data-gap="10"
                              data-direction="column"
                            >
                              <text
                                data-position="bottom"
                                data-text-size="large"
                                data-color="white"
                              >
                                Logements
                              </text>
                            </group>
                          </group>
                        </group>
                      </wrap>
                    </label>
                    <label className="" data-length="260">
                      <input type="radio" value="value" name="radio" />
                      <wrap
                        data-gap="15"
                        data-min-height="72"
                        data-name="inactive"
                      >
                        <group
                          data-gap="10"
                          data-radius="extra-special"
                          data-contain=""
                        >
                          <group
                            data-gap="20"
                            data-height="100"
                            data-interactive=""
                            data-cursor="pointer"
                          >
                            <picture data-position="absolute">
                              <img
                                src="/src/styles/images/cards/Card-Batiment-8.png"
                                alt=""
                              />
                            </picture>
                            <group
                              data-width="auto"
                              data-height="autofit"
                              data-space="20"
                              data-gap="10"
                              data-direction="column"
                            >
                              <text
                                data-position="bottom"
                                data-text-size="large"
                                data-color="white"
                              >
                                Logements
                              </text>
                            </group>
                          </group>
                        </group>
                      </wrap>
                    </label>
                    <label className="" data-length="260">
                      <input type="radio" value="value" name="radio" />
                      <wrap
                        data-gap="15"
                        data-min-height="72"
                        data-name="inactive"
                      >
                        <group
                          data-gap="10"
                          data-radius="extra-special"
                          data-contain=""
                        >
                          <group
                            data-gap="20"
                            data-height="100"
                            data-interactive=""
                            data-cursor="pointer"
                          >
                            <picture data-position="absolute">
                              <img
                                src="/src/styles/images/cards/Card-Batiment-9.png"
                                alt=""
                              />
                            </picture>
                            <group
                              data-width="auto"
                              data-height="autofit"
                              data-space="20"
                              data-gap="10"
                              data-direction="column"
                            >
                              <text
                                data-position="bottom"
                                data-text-size="large"
                                data-color="white"
                              >
                                Logements
                              </text>
                            </group>
                          </group>
                        </group>
                      </wrap>
                    </label>
                  </div>
                </group>
              </group>
            </group>
          </group>

          <group
            data-wrap="no"
            data-name="progress_bar"
            data-direction="column"
          >
            <group>
              <group
                data-wrap="no"
                data-gap="20"
                data-width="auto"
                data-name="progress_bar_header"
              >
                <group
                  data-name="progress_bar_point"
                  data-background="grey-color-mid"
                  data-length="30"
                  data-height="30"
                  data-color="white"
                  data-align="center"
                  data-justify="center"
                  data-text-size="13"
                  data-weight="700"
                  data-radius="40"
                  data-shrink="no"
                >
                  6
                </group>
                <group
                  data-align="center"
                  data-width="auto"
                  data-name="progress_bar_title"
                >
                  <text
                    data-weight="400"
                    data-text-size="22"
                    data-ellipsis=""
                    data-color="grey-color-mid"
                  >
                    Circuits chauffage existants
                  </text>
                </group>
              </group>
            </group>
            <group data-wrap="no" data-gap="20">
              <group
                data-direction="column"
                data-wrap="no"
                data-length="30"
                data-gap="1"
                data-contain=""
              >
                {/*<group data-background="accent-dark" data-length="2" data-height="autofit" data-position="center"></group>*/}
              </group>
              <group
                data-length="autofit"
                //data-space-bottom="50"
                data-space-top="20"
              ></group>
            </group>
          </group>
        </group>
      </view>
    </view>
  );
};
export default Form;
